import React from 'react';

import {Heading} from 'components/Heading';
import FeatureItem from './FeatureItem';
import {prepareData} from 'utils/googleData'
import { heading } from 'components/Home/classes'

  export default function Features(props)  {
    const {enable,title,subtitle,description,cta,direction,style,gatsbyImage,items,gatsbyImage2}= prepareData({props})
    if ((enable === false || enable?.toLowerCase?.() === 'false') && !process.env.RENDER_DISABLED_COMPONENTS) {
  return <></>
}
    return (
  <section className={`features safe-paddings relative overflow-hidden pt-30 pb-40 lg:pt-24 lg:pb-32 md:pt-18 md:pb-28 sm:pt-12 sm:pb-18 ${style}`}>
    <div className={`container relative z-10 `}  >

      <h2 className={heading('title', 'primary', 'my-6')}>
                {title}
            </h2>

      <ul className="list-none xl:mt-20 lg:grid lg:grid-cols-3 lg:gap-x-8 xl:gap-y-20 lg:mt-16 lg:gap-y-16 md:mt-14 md:grid md:grid-cols-2 md:gap-x-6 md:gap-y-14 mt-10 flex flex-col items-center gap-0 space-y-10 text-center">
      {items?.length > 0 &&  items.map((item, index) =>{
        const   {  title, description,lottie,animationData } = item
        return (
        <FeatureItem animationData={animationData} title={title} description={description} key={index} />
         )
           })}
      </ul>
    </div>

  </section>
);
  }
